'use strict';

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.function.name");

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

Object.defineProperty(exports, "__esModule", {
  value: !0
});

function _interopDefault(a) {
  return a && "object" == typeof a && "default" in a ? a["default"] : a;
}

var React = require("react"),
    React__default = _interopDefault(React),
    PropTypes = _interopDefault(require("prop-types")),
    uncontrollable = require("uncontrollable"),
    vjs = _interopDefault(require("validate.js")),
    crypto = _interopDefault(require("crypto"));

function _typeof(a) {
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
    return typeof a;
  } : function (a) {
    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _typeof(a);
}

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread2(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(b, !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(b).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _objectWithoutPropertiesLoose(a, b) {
  if (null == a) return {};
  var c,
      d,
      e = {},
      f = Object.keys(a);

  for (d = 0; d < f.length; d++) {
    c = f[d], 0 <= b.indexOf(c) || (e[c] = a[c]);
  }

  return e;
}

function _objectWithoutProperties(a, b) {
  if (null == a) return {};

  var c,
      d,
      e = _objectWithoutPropertiesLoose(a, b);

  if (Object.getOwnPropertySymbols) {
    var f = Object.getOwnPropertySymbols(a);

    for (d = 0; d < f.length; d++) {
      c = f[d], !(0 <= b.indexOf(c)) && Object.prototype.propertyIsEnumerable.call(a, c) && (e[c] = a[c]);
    }
  }

  return e;
}

function _slicedToArray(a, b) {
  return _arrayWithHoles(a) || _iterableToArrayLimit(a, b) || _nonIterableRest();
}

function _toConsumableArray(a) {
  return _arrayWithoutHoles(a) || _iterableToArray(a) || _nonIterableSpread();
}

function _arrayWithoutHoles(a) {
  if (Array.isArray(a)) {
    for (var b = 0, c = Array(a.length); b < a.length; b++) {
      c[b] = a[b];
    }

    return c;
  }
}

function _arrayWithHoles(a) {
  if (Array.isArray(a)) return a;
}

function _iterableToArray(a) {
  if (Symbol.iterator in Object(a) || "[object Arguments]" === Object.prototype.toString.call(a)) return Array.from(a);
}

function _iterableToArrayLimit(a, b) {
  var c = [],
      d = !0,
      e = !1,
      f = void 0;

  try {
    for (var g, h = a[Symbol.iterator](); !(d = (g = h.next()).done) && (c.push(g.value), !(b && c.length === b)); d = !0) {
      ;
    }
  } catch (a) {
    e = !0, f = a;
  } finally {
    try {
      d || null == h["return"] || h["return"]();
    } finally {
      if (e) throw f;
    }
  }

  return c;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function single(a, b) {
  return vjs.single(a, b, {
    fullMessages: !1
  });
}

function multiple(a, b) {
  var c = vjs(a, b, {
    fullMessages: !1
  }) || {};
  return Object.keys(c).reduce(function (a, b) {
    return _objectSpread2({}, a, _defineProperty({}, b, c[b][0]));
  }, {});
}

function arrayOf() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : [],
      b = 1 < arguments.length ? arguments[1] : void 0,
      c = "shape" in b ? function (a) {
    return multiple(a, b.shape);
  } : function (a) {
    return single(a, b);
  },
      d = a.map(c);
  return d.filter(function (a) {
    return "object" !== _typeof(a) || 0 < Object.keys(a).length;
  }).length ? [d] : void 0;
}

function number(a, b) {
  return single(a, {
    numericality: _objectSpread2({}, b, {
      strict: !0
    })
  });
}

function required(a, b) {
  return single(a, {
    presence: _objectSpread2({}, b, {
      allowEmpty: !1
    })
  });
}

function shape() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      b = 1 < arguments.length ? arguments[1] : void 0;
  return multiple(a, b);
}

vjs.validators = _objectSpread2({}, vjs.validators, {
  arrayOf: arrayOf,
  number: number,
  oneOf: vjs.validators.inclusion,
  required: required,
  shape: shape
});

var Context = React.createContext({
  error: {},
  set: function set() {},
  unset: function unset() {},
  value: {}
}),
    Provider = Context.Provider,
    useForm = function useForm() {
  return React.useContext(Context);
},
    useStatus = function useStatus(a) {
  var b = React.useRef({
    error: void 0,
    value: void 0
  }),
      c = new Proxy({}, {
    get: function get(a, c) {
      return b.current[c];
    }
  }),
      d = React.useCallback(function (a, c) {
    b.current = {
      error: a,
      value: c
    };
  }, [b]),
      e = React.useCallback(function (a) {
    d(a, b.current.value);
  }, [d]),
      f = React.useCallback(function (a) {
    d(b.current.error, a);
  }, [d]);
  return (JSON.stringify(a.error) !== JSON.stringify(c.error) || JSON.stringify(a.value) !== JSON.stringify(c.value)) && d(a.error, a.value), [c, f, e];
},
    useValue = function useValue(a) {
  var b = useForm(),
      c = b.set,
      d = b.unset,
      e = _objectWithoutProperties(b, ["set", "unset"]);

  return {
    error: e.error[a],
    value: e.value[a]
  };
},
    Form = function Form(a) {
  var b = a.children,
      c = a.constraint,
      d = a.forwardedRef,
      e = a.onInvalid,
      f = void 0 === e ? function () {} : e,
      g = a.onSubmit,
      h = void 0 === g ? function () {} : g,
      i = _objectWithoutProperties(a, ["children", "constraint", "forwardedRef", "onInvalid", "onSubmit"]),
      j = uncontrollable.useUncontrolled(i, {
    error: "onErrorChange",
    value: "onChange"
  }),
      k = j.onChange,
      l = j.onErrorChange,
      m = _objectWithoutProperties(j, ["onChange", "onErrorChange"]),
      n = useStatus({
    error: m.error || {},
    value: m.value || {}
  }),
      o = _slicedToArray(n, 3),
      p = o[0],
      q = o[1],
      r = o[2],
      s = React.useCallback(function (a, b, c) {
    k(b, c);

    var d = _objectSpread2({}, p.error);

    delete d[a], JSON.stringify(d) !== JSON.stringify(p.error) && (r(d), l(d));
  }, [k, l]),
      t = React.useCallback(function (a, b) {
    var c = p.value,
        d = _objectSpread2({}, c, _defineProperty({}, a, b));

    q(d), s(a, d, c);
  }, [s]),
      u = React.useCallback(function (a) {
    var b = p.value,
        c = _objectSpread2({}, b);

    delete c[a], q(c), s(a, c, b);
  }, [s]),
      v = React.useMemo(function () {
    return {
      error: p.error,
      set: t,
      unset: u,
      value: p.value
    };
  }, [JSON.stringify(p.error), t, u, JSON.stringify(p.value)]),
      w = _objectSpread2({}, i);

  return delete w.error, delete w.onChange, delete w.onErrorChange, delete w.value, React__default.createElement("form", _extends({
    noValidate: !0
  }, w, {
    ref: d,
    onSubmit: function onSubmit(a) {
      a.preventDefault();
      var b = multiple(p.value, c),
          d = 0 === Object.keys(b).length;
      d ? h(p.value) : (l(b), f(b));
    }
  }), React__default.createElement(Provider, {
    value: v
  }, b));
};

Form.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  constraint: PropTypes.object,
  error: PropTypes.object,
  forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(PropTypes.element)
  })]),
  onChange: PropTypes.func,
  onErrorChange: PropTypes.func,
  onInvalid: PropTypes.func,
  onSubmit: PropTypes.func,
  value: PropTypes.object
};

var Form$1 = React.memo(React.forwardRef(function (a, b) {
  return React__default.createElement(Form, _extends({}, a, {
    forwardedRef: b
  }));
})),
    Blocker = function Blocker(a) {
  var b = a.children;
  return React__default.createElement(Provider, {
    value: {
      error: {},
      set: function set() {},
      unset: function unset() {},
      value: {}
    }
  }, b);
};

Blocker.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

function wrap(a, b) {
  return b(a);
}

var Collection = function Collection(a) {
  var b = a.value;
  return React__default.createElement("ul", null, b.map(function (a, b) {
    return a && React__default.createElement("li", {
      key: b
    }, "#", b, ": ", React__default.createElement(Error, {
      root: !1,
      value: a
    }));
  }));
};

Collection.propTypes = {
  value: PropTypes.array
};

var Literal = function Literal(a) {
  var b = a.value;
  return React__default.createElement("span", null, b);
};

Literal.propTypes = {
  value: PropTypes.string
};

var Map = function Map(a) {
  var b = a.value;
  return React__default.createElement("ul", null, Object.entries(b).map(function (a) {
    var b = _slicedToArray(a, 2),
        c = b[0],
        d = b[1];

    return React__default.createElement("li", null, c, ": ", React__default.createElement(Error, {
      root: !1,
      value: d
    }));
  }));
};

Map.propTypes = {
  value: PropTypes.object
};

var Root = function Root(a) {
  var b = a.children;
  return React__default.createElement("div", {
    role: "alert"
  }, b);
};

Root.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

var Nested = function Nested(a) {
  var b = a.children;
  return b;
},
    Error = function Error(a) {
  var b,
      c = a.root,
      d = a.value,
      e = useForm(),
      f = d || e.error || {};

  switch (!0) {
    case Array.isArray(f):
      b = Collection;
      break;

    case "object" === _typeof(f):
      b = Map;
      break;

    default:
      b = Literal;
  }

  return wrap(React__default.createElement(b, {
    value: f
  }), !(void 0 !== c) || c ? Root : Nested);
};

Error.propTypes = {
  root: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
};

function identity(a) {
  return a;
}

function withProvider(a) {
  return React__default.createElement(Blocker, null, a);
}

var useField = function a(b) {
  if ("string" == typeof b) return a({
    name: b
  });

  var c = b.name,
      d = _objectWithoutProperties(b, ["name"]),
      e = useForm(),
      f = e.set,
      g = e.unset,
      h = _objectWithoutProperties(e, ["set", "unset"]),
      i = uncontrollable.useUncontrolled(_objectSpread2({}, d, {
    error: d.error === void 0 ? h.error[c] : d.error,
    value: d.value === void 0 ? h.value[c] : d.value
  }), {
    error: "onInvalid",
    value: "onChange"
  }),
      j = i.error,
      k = i.onChange,
      l = void 0 === k ? function () {} : k,
      m = i.onInvalid,
      n = void 0 === m ? function () {} : m,
      o = i.value;

  React.useDebugValue({
    error: j,
    value: o
  }), React.useEffect(function () {
    return void 0 !== o && JSON.stringify(o) !== JSON.stringify(h.value[c]) && f(c, o), function () {
      g(c);
    };
  }, []), React.useEffect(function () {
    j !== void 0 && n(j);
  }, [JSON.stringify(j)]);
  var p = React.useCallback(function (a) {
    f(c, a), l(a, o);
  }, [c, f, JSON.stringify(o)]);
  return _objectSpread2({}, d, {
    error: j,
    name: c,
    onChange: p,
    value: o
  });
},
    Field = function Field(a) {
  var b = a.children,
      c = void 0 === b ? function () {} : b,
      d = a.isolate,
      e = _objectWithoutProperties(a, ["children", "isolate"]),
      f = useField(e),
      g = f.error,
      h = f.onChange,
      i = void 0 === h ? function () {} : h,
      j = f.value;

  return (!(void 0 !== d) || d ? withProvider : identity)(c({
    error: g,
    onChange: i,
    value: j
  }));
};

Field.propTypes = {
  children: PropTypes.func,
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  isolate: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onInvalid: PropTypes.func,
  value: PropTypes.any
};

var Field$1 = React.memo(Field),
    Fieldset = function Fieldset(a) {
  var b = a.children,
      c = a.forwardedRef,
      d = a.legend,
      e = _objectWithoutProperties(a, ["children", "forwardedRef", "legend"]),
      f = useField(e),
      g = f.onChange,
      h = void 0 === g ? function () {} : g,
      i = _objectWithoutProperties(f, ["onChange"]),
      j = useStatus({
    error: i.error || {},
    value: i.value || {}
  }),
      k = _slicedToArray(j, 2),
      l = k[0],
      m = k[1],
      n = React.useCallback(function (a, b) {
    var c = l.value,
        d = _objectSpread2({}, c, _defineProperty({}, a, b));

    m(d), h(d, c);
  }, [h]),
      o = React.useCallback(function (a) {
    var b = l.value,
        c = _objectSpread2({}, b);

    delete c[a], m(c), h(c, b);
  }, [h]),
      p = React.useMemo(function () {
    return {
      error: l.error,
      set: n,
      unset: o,
      value: l.value
    };
  }, [JSON.stringify(l.error), n, o, JSON.stringify(l.value)]);

  return React__default.createElement(Provider, {
    value: p
  }, React__default.createElement("fieldset", _extends({}, i, {
    ref: c
  }), d && React__default.createElement("legend", null, d), b));
};

Fieldset.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  error: PropTypes.object,
  forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(PropTypes.element)
  })]),
  legend: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.object
};

for (var Fieldset$1 = React.memo(React.forwardRef(function (a, b) {
  return React__default.createElement(Fieldset, _extends({}, a, {
    forwardedRef: b
  }));
})), rng = function rng() {
  return crypto.randomBytes(16);
}, byteToHex = [], i = 0; 256 > i; ++i) {
  byteToHex[i] = (i + 256).toString(16).substr(1);
}

function bytesToUuid(a, b) {
  var c = b || 0,
      d = byteToHex;
  return [d[a[c++]], d[a[c++]], d[a[c++]], d[a[c++]], "-", d[a[c++]], d[a[c++]], "-", d[a[c++]], d[a[c++]], "-", d[a[c++]], d[a[c++]], "-", d[a[c++]], d[a[c++]], d[a[c++]], d[a[c++]], d[a[c++]], d[a[c++]]].join("");
}

var bytesToUuid_1 = bytesToUuid;

function v4(a, b, c) {
  var d = b && c || 0;
  "string" == typeof a && (b = "binary" === a ? Array(16) : null, a = null), a = a || {};
  var e = a.random || (a.rng || rng)();
  if (e[6] = 64 | 15 & e[6], e[8] = 128 | 63 & e[8], b) for (var f = 0; 16 > f; ++f) {
    b[d + f] = e[f];
  }
  return b || bytesToUuid_1(e);
}

var v4_1 = v4;

function memoize(a) {
  var b = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : function (a) {
    return a;
  },
      c = function c() {
    var d = c.cache,
        e = b.apply(void 0, arguments);
    return e in d || (d[e] = a.apply(void 0, arguments)), d[e];
  };

  return c.cache = {}, c;
}

var Table = function Table(a) {
  var b = a.children,
      c = void 0 === b ? function () {} : b,
      d = _objectWithoutProperties(a, ["children"]),
      e = useField(d),
      f = e.onChange,
      g = void 0 === f ? function () {} : f,
      h = _objectWithoutProperties(e, ["onChange"]),
      i = useStatus({
    error: h.error || [],
    value: h.value || []
  }),
      j = _slicedToArray(i, 2),
      k = j[0],
      l = j[1],
      m = React.useRef(k.value),
      n = React.useRef(k.value.map(function () {
    return v4_1();
  }));

  JSON.stringify(m.current) !== JSON.stringify(k.value) && (m.current = k.value, n.current = k.value.map(function () {
    return v4_1();
  }));
  var o = React.useCallback(function (a) {
    var b = k.value,
        c = [].concat(_toConsumableArray(b), [a]);
    m.current = c, n.current.push(v4_1()), l(c), g(c, b);
  }, [g]),
      p = React.useCallback(memoize(function (a) {
    return function () {
      var b = n.current.indexOf(a);

      if (-1 !== b) {
        var c = k.value,
            d = c.filter(function (a, c) {
          return c !== b;
        });
        m.current = d, n.current = n.current.filter(function (a, c) {
          return c !== b;
        }), l(d), g(d, c);
      }
    };
  }), [g]),
      q = React.useCallback(function (a, b) {
    var c = n.current.indexOf(a);

    if (-1 !== c) {
      var d = k.value,
          e = _toConsumableArray(d);

      e[c] = b, m.current = e, l(e), g(e, d);
    }
  }, [g]),
      r = React.useCallback(function (a) {
    var b = n.current.indexOf(a);

    if (-1 !== b) {
      var c = k.value,
          d = _toConsumableArray(c);

      delete d[b], m.current = d, l(d), g(d, c);
    }
  }, [g]),
      s = React.useMemo(function () {
    var a = n.current.reduce(function (a, b, c) {
      return _objectSpread2({}, a, _defineProperty({}, b, k.error[c]));
    }, {}),
        b = n.current.reduce(function (a, b, c) {
      return _objectSpread2({}, a, _defineProperty({}, b, k.value[c]));
    }, {});
    return {
      error: a,
      set: q,
      unset: r,
      value: b
    };
  }, [JSON.stringify(k.error), q, r, JSON.stringify(k.value)]);
  return React__default.createElement(Provider, {
    value: s
  }, n.current.map(function (a, b, e) {
    return React__default.createElement(Field$1, {
      key: a,
      name: a
    }, function (f) {
      return c(_objectSpread2({}, f, {
        $add: o,
        $remove: p(a),
        array: e,
        index: b,
        name: "".concat(d.name, "-").concat(a)
      }));
    });
  }));
};

Table.propTypes = {
  children: PropTypes.func.isRequired,
  error: PropTypes.array,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.array
};

var Table$1 = React.memo(Table),
    Input = function Input(a) {
  var b = a.forwardedRef,
      c = _objectWithoutProperties(a, ["forwardedRef"]),
      d = useField(c),
      e = d.error,
      f = d.onBlur,
      g = void 0 === f ? function () {} : f,
      h = d.onChange,
      i = void 0 === h ? function () {} : h,
      j = d.onFocus,
      k = void 0 === j ? function () {} : j,
      l = d.type,
      m = void 0 === l ? "text" : l,
      n = d.value,
      o = void 0 === n ? "" : n,
      p = _objectWithoutProperties(d, ["error", "onBlur", "onChange", "onFocus", "type", "value"]);

  return React__default.createElement("input", _extends({}, p, {
    "data-error": !!e,
    "data-value": o,
    onBlur: function onBlur() {
      g();
    },
    onChange: function onChange(a) {
      var b = a.target.value;
      a.stopPropagation(), i(b);
    },
    onFocus: function onFocus() {
      k();
    },
    ref: b,
    type: m,
    value: o
  }));
};

Input.propTypes = {
  error: PropTypes.string,
  forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(PropTypes.element)
  })]),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  type: PropTypes.string,
  value: PropTypes.string
};

var Input$1 = React.forwardRef(function (a, b) {
  return React__default.createElement(Input, _extends({}, a, {
    forwardedRef: b
  }));
}),
    Checkbox = function Checkbox(a) {
  var b = a.forwardedRef,
      c = _objectWithoutProperties(a, ["forwardedRef"]),
      d = useField(c),
      e = d.error,
      f = d.onBlur,
      g = void 0 === f ? function () {} : f,
      h = d.onChange,
      i = void 0 === h ? function () {} : h,
      j = d.onFocus,
      k = void 0 === j ? function () {} : j,
      l = d.value,
      m = void 0 !== l && l,
      n = _objectWithoutProperties(d, ["error", "onBlur", "onChange", "onFocus", "value"]);

  return React__default.createElement("input", _extends({}, n, {
    checked: m,
    "data-error": !!e,
    "data-value": m,
    onBlur: function onBlur() {
      g();
    },
    onChange: function onChange(a) {
      var b = a.target.checked;
      a.stopPropagation(), i(b);
    },
    onFocus: function onFocus() {
      k();
    },
    ref: b,
    type: "checkbox"
  }));
};

Checkbox.propTypes = {
  error: PropTypes.string,
  forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(PropTypes.element)
  })]),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  type: PropTypes.string,
  value: PropTypes.bool
};

var Checkbox$1 = React.forwardRef(function (a, b) {
  return React__default.createElement(Checkbox, _extends({}, a, {
    forwardedRef: b
  }));
}),
    File = function File(a) {
  var b = a.forwardedRef,
      c = _objectWithoutProperties(a, ["forwardedRef"]),
      d = useField(c),
      e = d.error,
      f = d.multiple,
      g = void 0 !== f && f,
      h = d.onBlur,
      i = void 0 === h ? function () {} : h,
      j = d.onChange,
      k = void 0 === j ? function () {} : j,
      l = d.onFocus,
      m = void 0 === l ? function () {} : l,
      n = _objectWithoutProperties(d, ["error", "multiple", "onBlur", "onChange", "onFocus"]);

  return React__default.createElement("input", _extends({}, n, {
    "data-error": !!e,
    "data-multiple": g,
    onBlur: function onBlur() {
      i();
    },
    onChange: function onChange(a) {
      var b = a.target.files;
      a.stopPropagation(), k(g ? b : b[0]);
    },
    onFocus: function onFocus() {
      m();
    },
    ref: b,
    type: "file"
  }));
};

File.propTypes = {
  error: PropTypes.string,
  forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(PropTypes.element)
  })]),
  multiple: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  type: PropTypes.string
};

var File$1 = React.forwardRef(function (a, b) {
  return React__default.createElement(File, _extends({}, a, {
    forwardedRef: b
  }));
}),
    Radio = function Radio(a) {
  var b = a.content,
      c = a.forwardedRef,
      d = _objectWithoutProperties(a, ["content", "forwardedRef"]),
      e = useField(d),
      f = e.error,
      g = e.onBlur,
      h = void 0 === g ? function () {} : g,
      i = e.onChange,
      j = void 0 === i ? function () {} : i,
      k = e.onFocus,
      l = void 0 === k ? function () {} : k,
      m = e.value,
      n = _objectWithoutProperties(e, ["error", "onBlur", "onChange", "onFocus", "value"]);

  return React__default.createElement("input", _extends({}, n, {
    checked: b === m,
    "data-checked": b === m,
    "data-error": !!f,
    "data-value": m,
    onBlur: function onBlur() {
      h();
    },
    onChange: function onChange(a) {
      var c = a.target.checked;
      a.stopPropagation(), j(c ? b : m);
    },
    onFocus: function onFocus() {
      l();
    },
    ref: c,
    type: "radio"
  }));
};

Radio.propTypes = {
  content: PropTypes.string,
  error: PropTypes.string,
  forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(PropTypes.element)
  })]),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  type: PropTypes.string,
  value: PropTypes.string
};

var Radio$1 = React.forwardRef(function (a, b) {
  return React__default.createElement(Radio, _extends({}, a, {
    forwardedRef: b
  }));
}),
    Select = function Select(a) {
  var b = a.children,
      c = a.forwardedRef,
      d = void 0 === c ? React.createRef() : c,
      e = _objectWithoutProperties(a, ["children", "forwardedRef"]),
      f = useField(e),
      g = f.error,
      h = f.multiple,
      i = void 0 !== h && h,
      j = f.onBlur,
      k = void 0 === j ? function () {} : j,
      l = f.onChange,
      m = void 0 === l ? function () {} : l,
      n = f.onFocus,
      o = void 0 === n ? function () {} : n,
      p = f.value,
      q = _objectWithoutProperties(f, ["error", "multiple", "onBlur", "onChange", "onFocus", "value"]),
      r = React.useRef(null),
      s = function s(a) {
    var b = Array.from(r.current.options);
    return b.find(function (b) {
      var c = b.value;
      return c === a;
    }) || (i ? void 0 : b[0]);
  },
      t = function t(a) {
    var b = Array.from(r.current.options),
        c = Array.isArray(a) ? a : [a],
        d = c.map(function (a) {
      return s(a);
    }).filter(Boolean).map(function (a) {
      return a.value;
    });

    if (0 === d.length && !i) {
      var e = b[0] || {};
      d = [e.value];
    }

    return i ? d : d[0];
  };

  return React.useEffect(function () {
    if (void 0 === p) {
      var a = t(p);
      m(a);
    }
  }, []), React__default.createElement("select", _extends({}, q, {
    "data-error": !!g,
    "data-multiple": i,
    "data-value": p,
    multiple: i,
    onBlur: function onBlur() {
      k();
    },
    onChange: function onChange(a) {
      var b = a.target.selectedOptions;
      a.stopPropagation();
      var c = Array.from(b).map(function (a) {
        return a.value;
      }),
          d = t(c);
      m(d);
    },
    onFocus: function onFocus() {
      o();
    },
    ref: function ref(a) {
      r.current = a, d.current = a;
    },
    value: p
  }), b);
};

Select.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  error: PropTypes.string,
  forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(PropTypes.element)
  })]),
  multiple: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  type: PropTypes.string
};

var Select$1 = React.forwardRef(function (a, b) {
  return React__default.createElement(Select, _extends({}, a, {
    forwardedRef: b
  }));
}),
    Textarea = function Textarea(a) {
  var b = a.forwardedRef,
      c = _objectWithoutProperties(a, ["forwardedRef"]),
      d = useField(c),
      e = d.error,
      f = d.onBlur,
      g = void 0 === f ? function () {} : f,
      h = d.onChange,
      i = void 0 === h ? function () {} : h,
      j = d.onFocus,
      k = void 0 === j ? function () {} : j,
      l = d.value,
      m = void 0 === l ? "" : l,
      n = _objectWithoutProperties(d, ["error", "onBlur", "onChange", "onFocus", "value"]);

  return React__default.createElement("textarea", _extends({}, n, {
    "data-error": !!e,
    "data-value": m,
    onBlur: function onBlur() {
      g();
    },
    onChange: function onChange(a) {
      var b = a.target.value;
      a.stopPropagation(), i(b);
    },
    onFocus: function onFocus() {
      k();
    },
    value: m
  }));
};

Textarea.propTypes = {
  error: PropTypes.string,
  forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(PropTypes.element)
  })]),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  type: PropTypes.string,
  value: PropTypes.string
};
var Textarea$1 = React.forwardRef(function (a, b) {
  return React__default.createElement(Textarea, _extends({}, a, {
    forwardedRef: b
  }));
});
exports.Blocker = Blocker, exports.Checkbox = Checkbox$1, exports.Error = Error, exports.Field = Field$1, exports.Fieldset = Fieldset$1, exports.File = File$1, exports.Form = Form$1, exports.Input = Input$1, exports.Radio = Radio$1, exports.Select = Select$1, exports.Table = Table$1, exports.Textarea = Textarea$1, exports.default = Form$1, exports.useField = useField, exports.useValue = useValue;